export const SUPPORTED_NOTIFICATION_TYPES = [];

export const ONLY_MALE = 'only_male_participants';
export const UNDER_12 = 'age_under_12';
export const ABOVE_90 = 'age_above_90';
export const WITHOUT_COUPON = 'company_project_without_coupon';
export const DUPLICATE_EMAIL = 'participants_with_duplicate_email';
export const TEAM_SIZE_REACHED = 'max_team_size_goals_reached';
